// extracted by mini-css-extract-plugin
export default {"notificationCard":"Notification_notificationCard__7xi7Q","notificationCard__header":"Notification_notificationCard__header__Mvcac"};